import actions from './actions';

const initState = {
  pageMemberships: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 0,
  },
  loading: false,
  error: '',
  lastUpdated: null,
};

export default function pageMembershipsReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_PAGE_MEMBERSHIPS:
    case actions.CREATE_PAGE_MEMBERSHIP:
    case actions.UPDATE_PAGE_MEMBERSHIP:
    case actions.DELETE_PAGE_MEMBERSHIP:
      return {
        ...state,
        loading: true,
        error: '',
      };

    case actions.GET_PAGE_MEMBERSHIPS_SUCCESS:
      return {
        ...state,
        pageMemberships: action.pageMemberships,
        pagination: action.pagination || state.pagination,
        loading: false,
        error: '',
        lastUpdated: new Date().toISOString(),
      };

    case actions.CREATE_PAGE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        pageMemberships: [...state.pageMemberships, action.pageMembership],
        loading: false,
        error: '',
      };

    case actions.UPDATE_PAGE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        pageMemberships: state.pageMemberships.map(membership =>
          membership.id === action.pageMembership.id ? action.pageMembership : membership
        ),
        loading: false,
        error: '',
      };

    case actions.DELETE_PAGE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        pageMemberships: state.pageMemberships.filter(membership => membership.id !== action.membershipId),
        loading: false,
        error: '',
      };

    case actions.GET_PAGE_MEMBERSHIPS_ERROR:
    case actions.CREATE_PAGE_MEMBERSHIP_ERROR:
    case actions.UPDATE_PAGE_MEMBERSHIP_ERROR:
    case actions.DELETE_PAGE_MEMBERSHIP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case actions.CLEAR_PAGE_MEMBERSHIPS_ERROR:
      return {
        ...state,
        error: '',
      };

    default:
      return state;
  }
}
